import { Map, fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.GET_TRAINING_TYPE + actions.FULFILLED:
            return fromJS(action.payload);

        case actions.SET_TRAINING_TYPE_FIELD:
            return state.set(action.field, action.payload);

        case actions.UPDATE_TRAINING_TYPE_NAME:{
            return state.set('name', action.payload)
        }
        case actions.UPDATE_TRAINING_TYPE_DESCRIPTION: {
            return state.set('description', action.payload)
        }
        case actions.NEW_TRAINING_TYPE:
            return getInitialState();


        default:
            return state;
    }
}

const getInitialState = () => {
    return Map({
        isActive: true
    });
};